import type { UpgradeEffect, Requirement } from './types';

/** An activatable ability: a player-triggered timed boost on a cooldown. */
export interface AbilityDef {
  id: string;
  name: string;
  icon: string;
  description: string;
  effect: UpgradeEffect;
  /** Active duration in seconds. */
  duration: number;
  /** Cooldown in seconds (from activation). */
  cooldown: number;
  requires?: Requirement & { lifetimeEarnings?: number };
}

export const ABILITIES: readonly AbilityDef[] = [
  {
    id: 'frenzy', name: 'Abbau-Rausch', icon: '🤜', effect: { type: 'clickMult', value: 7 },
    duration: 15, cooldown: 90,
    description: 'Klickkraft ×7 für 15s.',
  },
  {
    id: 'overdrive', name: 'Overdrive', icon: '⚡', effect: { type: 'autoMult', value: 8 },
    duration: 30, cooldown: 180,
    description: 'Gesamter Abbau-Ausstoß ×8 für 30s.',
    requires: { lifetimeEarnings: 5_000 },
  },
  {
    id: 'surge', name: 'Markt-Boom', icon: '📈', effect: { type: 'valueMult', value: 4 },
    duration: 25, cooldown: 150,
    description: 'Verkaufswert ×4 für 25s.',
    requires: { lifetimeEarnings: 5e4 },
  },
  {
    id: 'meltdown', name: 'Reaktor-Kernschmelze', icon: '☢️', effect: { type: 'globalMult', value: 5 },
    duration: 20, cooldown: 300,
    description: 'Alles ×5 für 20s.',
    requires: { lifetimeEarnings: 1e7, tech: 'powergrid' },
  },
] as const;

export const ABILITY_BY_ID: Record<string, AbilityDef> = Object.fromEntries(
  ABILITIES.map((a) => [a.id, a]),
);
